import * as Sentry from '@sentry/browser';

class AxiosWithSentry {
    constructor(config = {}) {
        if (Array.isArray(config)) {
            this.required = config;
            this.config = {};
        } else {
            this.config = config;
        }
    }
    logger(config) {
        let requestToken = Date.now()+Math.random().toString(36);
        let self = this;
        const url = new URL(self.url);
        const headers = url.host === EnvVars.app.host ? {
            headers: {
                'Request-Token': requestToken,
                'Page-Token': EnvVars.session.pageToken,
                'Window-Token': sessionStorage.windowToken,
            }
        } : {};
        return Object.assign({}, headers, {
            transformResponse: [function (data) {
                try {
                    if (self.data) {
                        Sentry.addBreadcrumb({
                            category: "request",
                            data: self.data,
                            level: Sentry.Severity.Log,
                        });
                    }
                    const dataSize = data.length;
                    let dataShorten = typeof data === 'string' 
                        ? (dataSize < 100000 ? data : data.substring(0, 100000) + ' (shorten)') 
                        : data;
                    data = JSON.parse(data);
                    Sentry.setContext("response", { data: dataSize < 100000 ? data : dataShorten });
                    Sentry.addBreadcrumb({
                        category: "response",
                        data: { data: data },
                        level: Sentry.Severity.Log,
                    });
                    if (data.errors && Array.isArray(data.errors)) {
                        return data;
                    }
                    if (self.required && !self.required.every(function(key) { return key in data; })) {
                        Sentry.captureException(new TypeError("Unexpected JSON response: "+self.url), {
                            tags: {
                                axiosUrl: self.url,
                                requestToken: requestToken,
                            },
                        });
                        Vue.prototype.$message({
                            message: 'An unexpected data received.',
                            type: `error`,
                        });
                    }
                } catch (e) {
                    if (typeof data === 'string') {
                        Sentry.setContext("response", { data: data.replace(/(&lt;([^>]+)>)/gi, "") });
                        Sentry.addBreadcrumb({
                            category: "response",
                            data: { data: data.replace(/(&lt;([^>]+)>)/gi, "") },
                            level: Sentry.Severity.Log,
                        });

                        if (data.indexOf('https://www.cloudflare.com/5xx-error-landing') > 0) {
                            let errors = _.join($.map($('div[class="clearfix"] p', $(data)), (message) => {
                                return $(message).html();
                            }), ' ');
                            data = { errors: [ errors ? errors : 'An unexpected error has occured.' ] };
                        }  
                    }
                }
                return data;
            }],
        }, this.config, Array.isArray(config) ? {} : config);
    }
    request(url, config = {}) {
        return window._axios.request(url, this.logger(config));
    }
    get(url, config = {}) {
        this.url = url;
        return window._axios.get(url, this.logger(config));
    }
    delete(url, config = {}) {
        this.url = url;
        return window._axios.delete(url, this.logger(config));
    }
    head(url, config = {}) {
        this.url = url;
        return window._axios.head(url, this.logger(config));
    }
    options(url, config = {}) {
        this.url = url;
        return window._axios.options(url, this.logger(config));
    }
    post(url, data, config = {}) {
        this.url = url;
        this.data = data;
        return window._axios.post(url, data, this.logger(config));
    }
    put(url, data, config = {}) {
        this.url = url;
        this.data = data;
        return window._axios.put(url, data, this.logger(config));
    }
    patch(url, data, config = {}) {
        this.url = url;
        this.data = data;
        return window._axios.patch(url, data, this.logger(config));
    }
    all(iterable) {
        return window._axios.all(iterable);
    }
    spread(callback) {
        return window._axios.spread(callback);
    }
}

class AxiosWithSentryDispatcher {
    create(config = {}) {
        return new AxiosWithSentry(config);
    }
    require(config = {}) {
        return this.create(config);
    }
    request(url, config = {}) {
        return this.create(config).request(url);
    }
    get(url, config = {}) {
        return this.create(config).get(url);
    }
    delete(url, config = {}) {
        return this.create(config).delete(url);
    }
    head(url, config = {}) {
        return this.create(config).head(url);
    }
    options(url, config = {}) {
        return this.create(config).options(url);
    }
    post(url, data, config = {}) {
        return this.create(config).post(url, data);
    }
    put(url, data, config = {}) {
        return this.create(config).put(url, data);
    }
    patch(url, data, config = {}) {
        return this.create(config).patch(url, data);
    }
    all(iterable) {
        return window._axios.all(iterable);
    }
    spread(callback) {
        return window._axios.spread(callback);
    }
}

axios = window.axios = new AxiosWithSentryDispatcher();
